<template>
  <div class="member-wrapper common-bottom-space" :class="{'hasBtn':list.length}">
    <div class="set-btn" v-if="list.length">
      <van-button plain type="info" icon="certificate" color="#35a8c6" :disabled="!unReadMessageNum" @click="updateMessageStatus()">
        一键置为全部已读
      </van-button>
    </div>
    <div class='content'>
      <van-pull-refresh v-model="page.refreshing" @refresh="onRefresh">
        <van-list class="message-wrap" v-model="page.loading" :finished="page.finished" finished-text="没有更多了" @load="onLoad">
          <van-cell class="list" v-for="item in list" :key='item.id'>
            <div class="top">
              <span class="type">{{item.MsgType|msgTypeText}}</span>
              <span class="date">{{item.CreateTime|momentTime("YYYY-MM-DD")}}</span>
            </div>
            <div class="bottom">
              <span class="title">{{item.NoticeContent}}<a :href="TcatUrl" v-if="setTcatHref(item.NoticeContent)" target="_blank">{{TcatUrl}}</a></span>
              <span>
                <i class="no-read-icon" v-if="!item.IsMSGRead"></i>
              </span>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
export default {
  data () {
    return {
      TcatUrl: 'https://i.eqxiu.com/s/orriIEqs?eqrcode=1',
      params: {
        AppID: this.GLOBAL.AppID,
        Method: 'SearchSystemMessage',
        PageIndex: 1,//页数索引
        PageSize: 20,//分页大小
        Sort: true,//排序顺序:false:顺序,true:倒序
        SortBy: 0,//排序字段:0:创建时间,1:消息类型
        Type: '',//消息类型:1:系统提醒,2:进度提醒,3:阶段提醒
        IsRead: '',//是否阅读:false:未读,true:已读
        Content: '',//消息内容:maxlength:500 
      },
      UpdateSystemMessagesRead: {
        AppID: this.GLOBAL.AppID,
        Method: 'UpdateSystemMessagesRead',
        SystemMessageIDs: '',//消息编号:多个编号用,隔开,预设置所有消息已读，传空 
      },
      page: {
        refreshing: false,
        loading: false,
        error: false,
        finished: false
      },
      list: [],
      unReadMessageNum: 0
    }
  },
  filters: {
    msgTypeText (type) {
      const typeList = {
        1: '系统提醒',
        2: '进度提醒',
        3: '阶段提醒'
      }
      return typeList[type];
    }
  },
  methods: {
    setTcatHref (str) {
      return str != undefined && str.indexOf('天猫服务门店招商计划') > -1
    },
    getMessageCount () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetSystemMessage'
      }).then(res => {
        this.unReadMessageNum = res.NoReadCount
        this.$store.commit('UPDATE_NOREADMESSAGECOUNT', res.NoReadCount);
      })
    },
    // 获取消息列表
    getMsgList () {
      this.$Request(this.params).then(res => {
        // 加载状态结束
        this.page.loading = false;
        this.list = this.list.concat(res.SystemMessageItems) || [];
        if (this.list.length >= res.Count) {
          this.page.finished = true;
        } else {
          this.params.PageIndex++;
        }
        this.getMessageCount()
      })
    },
    onLoad () {
      this.getMsgList();
    },
    // 下拉刷新
    onRefresh () {
      this.params.PageIndex = 1;
      setTimeout(() => {
        this.list = [];
        this.page.error = false;
        this.page.finished = false;
        this.page.refreshing = false;
        window.scrollTo(0, 10);
      }, 1000);
    },
    updateMessageStatus () {
      let methodParams = this.UpdateSystemMessagesRead
      methodParams.SystemMessageIDs = ''
      Dialog.confirm({
        title: '提示',
        message: '确认将所有消息全部设为已读吗?'
      }).then(() => {
        this.$Request(methodParams).then(res => {
          this.params.PageIndex = 1
          this.list = []
          this.getMsgList()
          this.getMessageCount()
        })
      }).catch(() => { })
    }
  }
}
</script>
<style lang="less" scoped>
.hasBtn .content {
  padding-top: 140px;
}
.set-btn {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: #ffffff;
  text-align: right;
  padding: 30px;
  box-shadow: 0px 0px 0px 5px rgba(238, 238, 238, 0.4);
  .van-button {
    border-radius: 20px;
  }
}
.content {
  padding: 0px 30px 0 30px;
  min-height: 100%;
  .img-icon {
    width: 60px;
    height: 60px;
    margin-right: 10px;
    background-color: #ddd;
  }
  .message-wrap {
    .list {
      font-size: 32px;
      margin-top: 20px;
      border-bottom: 1px solid #eeeeee;
      .top,
      .bottom {
        padding: 5px 0;
        width: 100%;
      }
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .date {
          color: @mGray;
          float: right;
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          word-break: break-all;
          color: #666666;
        }
        .no-read-icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: @red;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/member/message-center.vue